module.exports = __webpack_public_path__ + "static/media/question.d9816c43.svg";